import type { CheckoutPage as CheckoutPageProps } from '@/@types/content';
import withNav from '../hocs/withNav';
import ContentArea from '../cms/ContentArea';
import useCheckout from '../ui/CheckoutAndOrderManagement/hooks/useCheckoutHook';
import CheckoutAddressPanel from '../ui/CheckoutAndOrderManagement/CheckoutAddressPanel/CheckoutAddressPanel';

const CheckoutPageComponent: React.FC<CheckoutPageProps> = props => {
  const {
    isShippingRequired,
    selectedBillingAddress,
    selectedShippingAddress,
    isLoading,
    refetch,
    setBillingAddressSk,
    setShippingAddressSk
  } = useCheckout();

  return (
    <div className="bg-gray-feather">
      <div className="container module-spacing">
        <ContentArea
          components={props.aboveCheckoutContentArea}
          propertyName="AboveCheckoutPageContentArea"
        />
        <h1 className="heading-4 mb-[32px]">Checkout</h1>
        <div className="flex flex-col gap-[12px]">
          {isShippingRequired && (
            <CheckoutAddressPanel
              isLoadingCheckout={isLoading}
              type="shipping"
              selectedAddress={selectedShippingAddress}
              refetchCheckout={refetch}
              setAddressSk={setShippingAddressSk}
            />
          )}
          <CheckoutAddressPanel
            isShippingRequired={isShippingRequired}
            isLoadingCheckout={isLoading}
            type="billing"
            selectedAddress={selectedBillingAddress}
            refetchCheckout={refetch}
            setAddressSk={setBillingAddressSk}
          />
        </div>
        <ContentArea
          components={props.belowCheckoutContentArea}
          propertyName="BelowCheckoutPageContentArea"
        />
      </div>
    </div>
  );
};

const CheckoutPage = withNav(CheckoutPageComponent, true /*suppress nav*/);
export default CheckoutPage;
